var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8436 8.85447L12.3776 15.8531C12.328 15.8997 12.2692 15.9366 12.2044 15.9618C12.1396 15.987 12.0701 16 12 16C11.9299 16 11.8604 15.987 11.7956 15.9618C11.7308 15.9366 11.672 15.8997 11.6224 15.8531L4.15639 8.85447C4.05626 8.7606 4 8.63329 4 8.50054C4 8.36779 4.05626 8.24047 4.15639 8.1466C4.25653 8.05273 4.39235 8 4.53396 8C4.67558 8 4.81139 8.05273 4.91153 8.1466L12 14.7923L19.0885 8.1466C19.1886 8.05273 19.3244 8 19.466 8C19.6077 8 19.7435 8.05273 19.8436 8.1466C19.9437 8.24047 20 8.36779 20 8.50054C20 8.63329 19.9437 8.7606 19.8436 8.85447Z",
    fill: "#3D3D3D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/ChevronDown.cb26bfc929f97b9d7c7bc6afff019353.svg";
export { ForwardRef as ReactComponent };